import { Box, Slider as MuiSlider, Stack, styled } from '@mui/material'

export const StyledSlider = styled(MuiSlider, {
  shouldForwardProp: (prop) => prop !== 'sliderColor',
})<{ sliderColor: string }>(({ theme, sliderColor }) => ({
  color: sliderColor || theme.palette.primary.main,
  height: 6,
  '& .MuiSlider-thumb': {
    display: 'none',
  },
  '& .MuiSlider-track': {
    border: 'none',
  },
  '& .MuiSlider-rail': {
    opacity: 0.5,
    backgroundColor: theme.palette.grey[300],
  },
}))

export const SliderContainer = styled(Stack)({
  width: '100%',
  flexDirection: 'column',
  position: 'relative',
})

export const SliderValueContainer = styled(Box)(() => ({
  position: 'absolute',
  top: -14,
  transform: 'translateX(-50%)',
  display: 'flex',
  justifyContent: 'center',
  userSelect: 'none',
  cursor: 'pointer',
}))

export const SliderValueBubble = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'sliderColor',
})<{ sliderColor: string }>(({ sliderColor }) => ({
  backgroundColor: sliderColor,
  color: 'white',
  borderRadius: '50%',
  width: 24,
  height: 24,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: 'bold',
  fontSize: 11,
}))

export const SliderValueIndicator = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'sliderColor',
})<{ sliderColor: string }>(({ sliderColor }) => ({
  backgroundColor: sliderColor,
  width: 2,
  height: 14,
  top: 19,
  position: 'absolute',
}))

export const SliderRangeValues = styled(Box)({
  position: 'absolute',
  width: '100%',
  top: 20,
  display: 'flex',
  justifyContent: 'space-between',
})

export const SliderRangeText = styled(Box)(({ theme }) => ({
  color: theme.palette.grey[500],
  fontSize: 10,
}))
